export default function About() {
  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <div className="inline-block bg-cyan-100 text-cyan-700 px-4 py-2 rounded-full text-sm font-semibold mb-4">
            About Us
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-slate-800 mb-4">
            会社概要
          </h2>
        </div>

        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div>
            <div className="bg-gradient-to-br from-cyan-500 to-blue-600 p-8 rounded-lg text-white mb-8">
              <h3 className="text-3xl font-bold mb-4">事業運営に寄り添う実務サポートを</h3>
              <p className="text-lg leading-relaxed text-cyan-50">
                合同会社ｌｕｃｅは、法人のお客様に向けた各種サポートを通じて、日々の事業運営を円滑に進めるためのお手伝いを行います。丁寧な対応と着実な実務を重ね、安心して相談できる体制づくりを大切にしています。
              </p>
            </div>

            <div className="grid grid-cols-2 gap-4">
              <div className="bg-cyan-50 p-6 rounded-lg">
                <div className="w-12 h-12 flex items-center justify-center bg-cyan-500 rounded-lg mb-3">
                  <i className="ri-shield-check-line text-2xl text-white"></i>
                </div>
                <h4 className="font-bold text-slate-800 mb-2">丁寧対応</h4>
                <p className="text-sm text-slate-600">状況に応じて柔軟にご案内</p>
              </div>
              <div className="bg-cyan-50 p-6 rounded-lg">
                <div className="w-12 h-12 flex items-center justify-center bg-cyan-500 rounded-lg mb-3">
                  <i className="ri-customer-service-line text-2xl text-white"></i>
                </div>
                <h4 className="font-bold text-slate-800 mb-2">実務重視</h4>
                <p className="text-sm text-slate-600">法人ニーズに沿ってサポート</p>
              </div>
            </div>
          </div>

          <div className="bg-slate-50 p-8 rounded-lg">
            <div className="space-y-6">
              <div className="border-l-4 border-cyan-500 pl-6">
                <h4 className="text-sm font-semibold text-slate-500 mb-1">会社名</h4>
                <p className="text-lg font-bold text-slate-800">合同会社ｌｕｃｅ</p>
              </div>

              <div className="border-l-4 border-cyan-500 pl-6">
                <h4 className="text-sm font-semibold text-slate-500 mb-1">設立日</h4>
                <p className="text-lg font-bold text-slate-800">令和6年10月16日</p>
              </div>

              <div className="border-l-4 border-cyan-500 pl-6">
                <h4 className="text-sm font-semibold text-slate-500 mb-1">所在地</h4>
                <p className="text-lg font-bold text-slate-800">東京都世田谷区松原２丁目２１番１０号ＢＥＳ明大前コート１０２</p>
              </div>

              <div className="border-l-4 border-cyan-500 pl-6">
                <h4 className="text-sm font-semibold text-slate-500 mb-2">事業内容</h4>
                <ul className="space-y-2 text-slate-700">
                  <li className="flex items-start">
                    <i className="ri-checkbox-circle-fill text-cyan-500 mt-1 mr-2"></i>
                    <span>法人向け各種サポート業務</span>
                  </li>
                  <li className="flex items-start">
                    <i className="ri-checkbox-circle-fill text-cyan-500 mt-1 mr-2"></i>
                    <span>事業運営に関する実務支援</span>
                  </li>
                  <li className="flex items-start">
                    <i className="ri-checkbox-circle-fill text-cyan-500 mt-1 mr-2"></i>
                    <span>ご要望に応じた業務提案・対応</span>
                  </li>
                  <li className="flex items-start">
                    <i className="ri-checkbox-circle-fill text-cyan-500 mt-1 mr-2"></i>
                    <span>前各号に付随する関連業務</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
